<template>
    <Card :bordered="false" class="border-radius-0">
        <Form :ref="(e) => (refs.form = e)" layout="horizontal">
            <CTable :isLoading="isLoading"
                    :ref="(e) => { refs.table = e;  }"
                    v-model:columns="data.columns"
                    v-model:page="data.page"
                    :options="data.tableOptions"
                    :manages="data.manages"
                    :manageExtras="data.manageExtras"
                    :rowActions="data.rowActions"
                    :rowActionWidth="data.rowActionWidth"
                    :visibleSearch="false"
                    :clientSide="true"
                    :canRefresh="false"
                    v-if="props.acceptStatus"
            >
            </CTable>
        </Form>
    </Card>
</template>

<script>
    import { reactive, defineAsyncComponent, defineComponent } from "vue";
    import { Card, Form } from "ant-design-vue";
    import { initData, isLoading } from "./physical-analysis-topic-input-table.logic";
    import { state as stateApp } from "../../../../../app.logic";

    export default defineComponent({
        emits: ['loadedData'],
        components: {
            Card,
            Form,
            CTable: defineAsyncComponent(() => import("../../../../../components/table/CTable"))
        },
        props: {
            menuContext: { default: () => stateApp.menuContext },
            viewOnly: {},
            root: {},
            parent: {},
            useForm: {},
            parentData: {},
            acceptStatus: {},
            itemsKey: {},
            fetchCriteria: {},
            visibleSearch: {
                default: true
            },
            actionPrefix: {
                default: ''
            }
        },
        setup(props,  { emit }) {
            const refs = reactive({ form: null, table: null });
            const data = reactive({ rowProp: { gutter: 20 } });
            initData({ props, data, refs, emit });
            return { props, data, refs, isLoading };
        },
    });
</script>

/* ห้ามมาใส่ Scoped เพราะต้องการ Override a-input[disabled] */
<style>
    .input-number.disabled.bg-warning {
        background: var(--warning-color) !important;
    }

    .input-number.disabled.bg-danger {
        background: var(--danger-color) !important;
    }
</style>;